// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__305cz","actions":"GroupTable_actions__nC9zu","deleteModalFooter":"GroupTable_deleteModalFooter__1pXzn"};